// extracted by mini-css-extract-plugin
export default {"descriptionCell":"DescriptionsTableA_descriptionCell__2YWGj","table":"DescriptionsTableA_table__OJo3Z","tableCell":"DescriptionsTableA_tableCell__FCaBj"};